import React from 'react'

type Props = {
  children: React.ReactNode
}

export default function Centered({ children }: Props) {
  return <div className='d-flex justify-content-center'>{children}</div>
}
